import './qbo-account.scss';
import { useContext, useEffect, useState } from 'react';
import { QBOAccount, QBOItemIncomeAccount, QBOItemType } from '../../clients/quipli-service/qbo/qbo';
import { useQboApi } from '../../clients/quipli-service/qbo/qbo-api-v1';
import { Typography } from '../../components/typography/typography';
import './qbo-item-income-account.scss';
import { TenantContext } from '../../context/tenant-context';
import { toast } from '../../util/toasts';
import { ItemGeneralLedgerTransactionType } from '../../clients/quipli-service/accounting/accounting';
import { QboAccountSelect } from './qbo-account-select';

export const QboItemIncomeAccount = ({
  itemType,
  itemId,
  transactionType,
  label,
  accounts: defaultAccounts,
}: {
  itemType?: QBOItemType;
  itemId?: string;
  transactionType?: ItemGeneralLedgerTransactionType;
  label?: string;
  accounts?: QBOAccount[];
}) => {
  const { configuration } = useContext(TenantContext);
  const [accounts, setAccounts] = useState<QBOAccount[] | undefined>(defaultAccounts);
  const [incomeAccount, setIncomeAccount] = useState<QBOItemIncomeAccount>();
  const { listAccounts, getItemIncomeAccount, upsertItemIncomeAccount } = useQboApi();
  let qboEnabled = false;

  // @hipaa-exclude-start
  if (configuration?.qboEnabled) {
    qboEnabled = true;
  }

  useEffect(() => {
    if (qboEnabled && !defaultAccounts) {
      listAccounts()
        .then((accounts) => {
          setAccounts(accounts);
        })
        .catch((e) => {
          console.error(`Error loading QuickBooks accounts`, e);
          toast(`Error loading QuickBooks accounts`, 'error');
        });
    }
    getItemIncomeAccount(itemType, itemId, transactionType).then(setItemIncomeAccount);
  }, [configuration?.qboEnabled]);
  // @hipaa-exclude-end

  function setItemIncomeAccount(ia: QBOItemIncomeAccount | undefined) {
    if (
      ia &&
      (ia.itemType || undefined) === itemType &&
      (ia.itemId || undefined) === itemId &&
      (ia.transactionType || undefined) === transactionType
    ) {
      setIncomeAccount(ia);
    } else {
      setIncomeAccount(undefined);
    }
  }

  return (
    <div className="qbo-item-income-account container-v2">
      {qboEnabled && accounts && (
        <div className="flex flex-row">
          {label && (
            <label>
              <Typography type="text-md" weight="semi-bold">
                {label || 'General Ledger Account'}:
              </Typography>
            </label>
          )}
          <QboAccountSelect
            accountId={incomeAccount?.incomeAccount}
            onChange={(v) =>
              upsertItemIncomeAccount({
                itemType,
                itemId,
                transactionType,
                incomeAccount: v,
              }).then(setItemIncomeAccount)
            }
            accounts={accounts}
          />
        </div>
      )}
    </div>
  );
};
